export default {
  root: {
    width: '100%',

    '& *': {
      fontFamily:
        "'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace"
    }
  }
}
